<template>
  <div>
    <div class="btn-sm-drop statusbtn" v-show="fromList && !showDropdown" @click="toggleDropdown">
        <button class="btn btn-secondary m-md-2">{{ currentStatus }} <i class="fa fa-caret-down"></i></button>
    </div>
      <b-dropdown
        v-if="showDropdown || !fromList"
        id='ddown1' 
        :text='currentStatus'
        class='btn-sm-drop statusbtn m-md-2'
        @hidden="$emit('hidden')"
        @shown="$emit('shown')"
        ref="bDropdown"
      >
        <b-dropdown-item
        v-for='(status, index) in client_status'
        v-bind:key='index'
        v-on:click='changeStatus(status)'
        :disabled="toggledisabledstatus">
        {{status}}
        </b-dropdown-item>
      </b-dropdown>
  </div>
</template>
<script>
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import { mapMutations } from 'vuex';

export default {
  name: 'Dropdown',
  props: ['applicant', 'toggledisabledstatus','isReviewer','fromList'],
  data() {
    return {
      // current_status: this.applicant.status,
    client_status: [
        '未確認',
        '選考対象外',
        '選考対象、未対応',
        '確認中',
        '過去応募済み',
        'コンタクト済み',
        '返信有',
        // 'プッシュ済',
        
        // '応募有',
        '選考応募有',
        'システム取込み済み',
        
        '選考NG',
        '中長期的対応',
        'その他',
      ],
      showDropdown: false,
    };
  },
  computed: {
    currentStatus() {
      return this.applicant.status;
    },
  },
  methods: {
    ...mapMutations({
      mutateApplicantsAfterStatus: 'mutateApplicantsAfterStatus',
    }),
    toggleDropdown() {
      this.showDropdown = true;
      this.$nextTick(() => {
        if (this.$refs.bDropdown) {
          this.$refs.bDropdown.show(); // Open the dropdown first
          this.$nextTick(() => {
            this.$refs.bDropdown.$el.blur(); // Remove focus after opening
          });
        }
      });
    },

    hideDropdown() {
      this.showDropdown = false;
      this.$emit('hidden');
    },
    changeStatus(status) {
      // this.current_status = 'loading... ';
      ApiService.put(Api.endpoints.CLIENT_STATUS_CHANGE(this.applicant.id), {
        status,
      })// eslint-disable-next-line
        .then(({ data }) => {
          // this.current_status = status;
          this.$emit('statusChanged', status);
          // setTimeout(()=>{
          this.mutateApplicantsAfterStatus(data.data,this.isReviewer);
          // },1500)
          this.showDropdown = false;
        })
        .catch(({ response }) => this.parseErrorResponse(response));
    },
  },
};
</script>
<style scoped>
</style>

